export const RX_STATE_OPTIONS = [
  { title: 'AL', value: 'AL', name: 'Alabama' },
  { title: 'AK', value: 'AK', name: 'Alaska' },
  { title: 'AZ', value: 'AZ', name: 'Arizona' },
  { title: 'AR', value: 'AR', name: 'Arkansas' },
  { title: 'CA', value: 'CA', name: 'California' },
  { title: 'CO', value: 'CO', name: 'Colorado' },
  { title: 'CT', value: 'CT', name: 'Connecticut' },
  { title: 'DE', value: 'DE', name: 'Delaware' },
  { title: 'FL', value: 'FL', name: 'Florida' },
  { title: 'GA', value: 'GA', name: 'Georgia' },
  { title: 'HI', value: 'HI', name: 'Hawaii' },
  { title: 'ID', value: 'ID', name: 'Idaho' },
  { title: 'IL', value: 'IL', name: 'Illinois' },
  { title: 'IN', value: 'IN', name: 'Indiana' },
  { title: 'IA', value: 'IA', name: 'Iowa' },
  { title: 'KS', value: 'KS', name: 'Kansas' },
  { title: 'KY', value: 'KY', name: 'Kentucky' },
  { title: 'LA', value: 'LA', name: 'Louisiana' },
  { title: 'ME', value: 'ME', name: 'Maine' },
  { title: 'MD', value: 'MD', name: 'Maryland' },
  { title: 'MA', value: 'MA', name: 'Massachusetts' },
  { title: 'MI', value: 'MI', name: 'Michigan' },
  { title: 'MN', value: 'MN', name: 'Minnesota' },
  { title: 'MS', value: 'MS', name: 'Mississippi' },
  { title: 'MO', value: 'MO', name: 'Missouri' },
  { title: 'MT', value: 'MT', name: 'Montana' },
  { title: 'NE', value: 'NE', name: 'Nebraska' },
  { title: 'NV', value: 'NV', name: 'Nevada' },
  { title: 'NH', value: 'NH', name: 'New Hampshire' },
  { title: 'NJ', value: 'NJ', name: 'New Jersey' },
  { title: 'NM', value: 'NM', name: 'New Mexico' },
  { title: 'NY', value: 'NY', name: 'New York' },
  { title: 'NC', value: 'NC', name: 'North Carolina' },
  { title: 'ND', value: 'ND', name: 'North Dakota' },
  { title: 'OH', value: 'OH', name: 'Ohio' },
  { title: 'OK', value: 'OK', name: 'Oklahoma' },
  { title: 'OR', value: 'OR', name: 'Oregon' },
  { title: 'PA', value: 'PA', name: 'Pennsylvania' },
  { title: 'RI', value: 'RI', name: 'Rhode Island' },
  { title: 'SC', value: 'SC', name: 'South Carolina' },
  { title: 'SD', value: 'SD', name: 'South Dakota' },
  { title: 'TN', value: 'TN', name: 'Tennessee' },
  { title: 'TX', value: 'TX', name: 'Texas' },
  { title: 'UT', value: 'UT', name: 'Utah' },
  { title: 'VT', value: 'VT', name: 'Vermont' },
  { title: 'VA', value: 'VA', name: 'Virginia' },
  { title: 'WA', value: 'WA', name: 'Washington' },
  { title: 'WV', value: 'WV', name: 'West Virginia' },
  { title: 'WI', value: 'WI', name: 'Wisconsin' },
  { title: 'WY', value: 'WY', name: 'Wyoming' },
  { title: 'DC', value: 'DC', name: 'District of Columbia' },
  { title: 'PR', value: 'PR', name: 'Puerto Rico' },
  { title: 'GU', value: 'GU', name: 'Guam' },
  { title: 'AS', value: 'AS', name: 'American Samoa' },
  { title: 'MP', value: 'MP', name: 'Northern Mariana Islands' },
  { title: 'VI', value: 'VI', name: 'U.S. Virgin Islands' },
] as const;
